
import type { DevelopmentStage, TicketDevelopment } from '../model/types';

export const DEVELOPMENT_STAGES: readonly DevelopmentStage[] = [
  'queued',
  'planned',
  'in_progress',
  'review',
  'done',
];

export const DEVELOPMENT_STAGE_LABEL: Record<DevelopmentStage, string> = {
  queued: 'В очереди разработки',
  planned: 'Запланирована',
  in_progress: 'В работе',
  review: 'Ждёт вашей проверки',
  done: 'Готово',
};

export const DEVELOPMENT_STAGE_SHORT: Record<DevelopmentStage, string> = {
  queued: 'В очереди',
  planned: 'Запланирована',
  in_progress: 'В работе',
  review: 'Проверка',
  done: 'Готово',
};

const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export function dayText(iso: string, now = new Date()): string {
  const [y, m, d] = iso.split('-').map(Number);
  const base = `${d} ${MONTHS[(m ?? 1) - 1]}`;
  return y === now.getFullYear() ? base : `${base} ${y}`;
}

export function etaText(dev: TicketDevelopment, now = new Date()): string | null {
  if (dev.stage === 'done') return null;
  if (!dev.eta) return 'срок появится после планирования';
  if (dev.eta.overdue) return 'срок уточняется';
  return `ориентировочно к ${dayText(dev.eta.date, now)}`;
}

export const ETA_SOURCE_LABEL: Record<NonNullable<NonNullable<TicketDevelopment['eta']>['source']>, string> = {
  task_due: 'срок задачи',
  plan_span: 'отрезок на таймлайне',
  sprint_end: 'конец спринта',
  ticket_plan: 'плановая дата заявки',
};
